import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type RateClasses = 'rateContainer';

const rateStyles = makeStyles<ISpcTheme, RateClasses>(
  ({ breakpoints }) => ({
    rateContainer: {
      [breakpoints.down('md')]: {
        paddingTop: 0,
      },
    },
  }),
  { name: 'Customise_Rate' },
);

export default rateStyles;
